import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/auth";
import { isAdminRole } from "./types";

interface Props {
  children: React.ReactNode;
}

/**
 * AdminRouteGuard — wrap mọi /admin/* route.
 *
 * Logic L2 RBAC (defense-in-depth):
 *   1. Chưa auth → redirect /login (remember `from` để back sau login)
 *   2. Auth nhưng role student → redirect / (home)
 *   3. Auth + role admin scope (instructor/tenant_admin/superadmin) → render children
 *
 * L1 (BE permission_classes) + L3 (PermissionGate UI hide) là 2 layer còn lại.
 */
export function AdminRouteGuard({ children }: Props) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);
  const location = useLocation();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!isAdminRole(user.role)) {
    // Không log warning — đây là 403 expected, không phải bug
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
